import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Users'

export const UsersEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("register/AgentWebUser"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("CheckIsValidNewUsername"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("CheckIsValidEmail"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("LoginFromAgentsWeb"),

        new EndPointConfig()
        .setMethod("DELETE")
        .setController(controller)
        .setActionName("Logout"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("RecoverPassword"),     
        
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("ResendConfirmationEmail"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("RequestSignUpInOrganization"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("EditUserDataProfile"),


        new EndPointConfig()
        .setMethod("POST") // necesario para poder pasarle una lista
        .setController(controller)
        .setActionName("filter/AgentWebUser"),
       
      
        new EndPointConfig()
        .setMethod("DELETE")
        .setController(controller)
        .setActionName("Delete"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("create/AgentWebUser"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetAgentWebUserData"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("edit/AgentWebUser"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("confirmAccount/AgentWebUser"),   

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("ChangePassword"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetEmailByRecoveryHash"),


        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("CheckIfIntegrationSimulationIsAvailable"),

        
        
         
]

